<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent transition="dialog-top-transition" max-width="600px">
      <v-card>
        <div class="container-checkin">
          <div class="card-close">
            <img
              src="img/icons_v2/icon-close-black.png"
              width="40px"
              height="40px"
              @click="$emit('close')"
            />
          </div>

          <div class="card-title">
            <img
              :src="[
                status ? 'img/icons_v2/icon-checkin-blue.svg' : 'img/icons_v2/icon-checkin.svg'
              ]"
              :class="[status ? 'image image-checkin' : 'image image-checkout']"
            />
            <h1 v-if="status">ยืนยันการ Check-In</h1>
            <h1 v-else>ยืนยันการ Check-Out</h1>
          </div>

          <div v-if="!loaders" class="card-shop">
            <div class="description mx-4">
              <img src="img/icons_v2/image-customer.png" />
              <div class="d-flex flex-column">
                <span class="">{{ item.customer_name }}</span>
                <div class="d-flex">
                  <v-img max-width="30" src="img/icons_v2/icon-pin.svg"></v-img>
                  <div class="d-flex align-center text-blue px-3">
                    <span v-if="optionOpen">{{ item.distance }}{{ item.unit }}</span>
                    <span v-else>{{ distance.distance }}{{ distance.unit }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            <span>กรุณารอสักครู่ ระบบกำลังประมวล Location</span>
            <v-skeleton-loader type="list-item-avatar-two-line" />
          </div>

          <div class="mt-4">
            <button v-if="!loaders" class="bt-submit" @click="actionSave(item)">
              <span class="text-check">ตกลง</span>
            </button>

            <div v-else class="center">
              <v-skeleton-loader type="divider, actions" />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: ['dialog', 'item', 'status', 'optionOpen'],

  data() {
    return {
      loaders: true,
      distance: ''
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user
    })
  },

  watch: {
    dialog(newValue) {
      if (newValue) {
        this.loaders = true
        this.getLocation().then((res) => {
          this.getVisitDistance({ user_id: this.user.id, lat_lng: res }).then((result) => {
            this.distance = result
          })
          this.loaders = false
        })
      }
    }
  },

  methods: {
    ...mapActions({
      getLocation: 'checkinout/getLocation_V2',
      getVisitDistance: 'checkinout/getVisitDistance'
    }),

    actionSave(item) {
      this.$emit('save', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.container-checkin {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 50px;
  border-radius: 10px;
}

.card-close {
  & img {
    position: absolute;
    top: 0px;
    right: 0px;
    margin: 10px;
  }
}

.card-title {
  margin: 20px 0px;
}

.image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin-bottom: 15px;

  &-checkin {
    background: #ffebdb;
  }

  &-checkout {
    background: #edfff2;
  }
}

.card-shop {
  text-align: left;
  margin: 10px 0px;

  & .description {
    display: flex;
    justify-items: center;
    align-items: center;
    margin: 20px 0px;
    width: 100%;

    & img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-right: 20px;
    }
  }
}

.bt-submit {
  width: 100%;
  // background-color: #a50200;
  background: linear-gradient(270deg, #a9182a 0%, #d70a0a 100%);
  box-shadow: 5px 5px 18px rgba(0, 0, 0, 0.08);
  color: #ffffff;
  font-size: 25px;
  height: 65px;
  border-radius: 9px;
}

.bt-disabled {
  width: 100%;
  // background-color: #a50200;
  background: gray;
  box-shadow: 5px 5px 18px rgba(0, 0, 0, 0.08);
  color: #ffffff;
  font-size: 25px;
  height: 65px;
  border-radius: 9px;
}

.text-check {
  color: #ffffff;
  font-size: 30px;
}

.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 20px !important;
}
</style>
